import atLeastOneNecessary from './atLeastOneNecessary'
import verifyUnnecessaryScopes from './verifyUnnecessaryScopes'

const necessityAndProportionality = {
  atLeastOneNecessary,
  verifyUnnecessaryScopes,
}

export default necessityAndProportionality
